"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_hyperlink_1 = __importDefault(require("react-native-hyperlink"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const icons_1 = require("../../../assets/icons");
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Basic_1 = __importDefault(require("../../../networking/apis/Basic"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const components_2 = require("../components");
const components_3 = require("./components");
const styles_1 = __importDefault(require("./styles"));
const UserProfileScreen = (props) => {
    const { userHandle } = props.route.params;
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    // redirect if user is me
    if (userHandle == myProfile?.user_handle) {
        (0, rootNavigation_1.replace)(Routes_1.default.MY_PROFILE);
    }
    const [user, setUser] = (0, react_1.useState)();
    const [isBlocking, setBlocking] = (0, react_1.useState)(false);
    const [isBlocked, setBlocked] = (0, react_1.useState)(false);
    const [isMute, setMute] = (0, react_1.useState)(false);
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        if (connected) {
            getUserDetail();
        }
    }, [userHandle, connected]);
    const getUserDetail = () => {
        User_1.default.getUserDetailDashboard(userHandle)
            .then((response) => {
            setUser(response.data);
            setBlocking(response.data.is_blocking == 1);
            setBlocked(response.data.is_blocked == 1);
            setMute(response.data.is_muted == 1);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const toggleBlockUser = () => {
        (isBlocked ?
            Basic_1.default.unblockUser(user?.user_id)
            :
                Basic_1.default.blockUser(user?.user_id))
            .then(() => {
            dispatch(slice_1.default.actions.showToast(isBlocked ? 'ブロック解除しました' : 'ブロックしました'));
            setBlocked(!isBlocked);
        })
            .catch((err) => {
            console.log(err);
        });
    };
    const toggleMuteUser = () => {
        (isMute ?
            Basic_1.default.unMuteUser(user?.user_id)
            :
                Basic_1.default.muteUser(user?.user_id))
            .then(() => {
            dispatch(slice_1.default.actions.showToast(isMute ? 'ミュート解除しました' : 'ミュートしました'));
            setMute(!isMute);
        })
            .catch((err) => {
            console.log(err);
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: user?.user_handle ? `@${user?.user_handle}` : ' ', styleContainer: {
                backgroundColor: '#FEFEFE',
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#21242D' }), onLeftPress: rootNavigation_1.goBack }),
        !user ? (!isLoading &&
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.body },
                react_1.default.createElement(react_native_1.Image, { source: images_1.images.NoImages, resizeMode: "cover", style: styles_1.default.backgroundImage }),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.userInfo },
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.row,
                            {
                                justifyContent: 'space-between',
                                alignItems: 'flex-end',
                            },
                        ] },
                        react_1.default.createElement(react_native_1.Image, { source: images_1.images.AvatarDefaul, resizeMode: "cover", style: styles_1.default.avatar })),
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.row,
                            {
                                alignItems: 'center',
                                marginTop: (0, scale_1.scale)(8),
                            },
                        ] }),
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: [styles_1.default.blockTitle, { textAlign: 'center' }] }, "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u5B58\u5728\u3057\u307E\u305B\u3093")))) : (react_1.default.createElement(react_native_1.ScrollView, { style: styles_1.default.body, contentContainerStyle: {
                paddingBottom: inset.bottom + (0, scale_1.scale)(100),
            }, onScroll: ({ nativeEvent }) => {
                if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    new react_native_1.NativeEventEmitter().emit(constants_1.listenerEvents.PROFILE_REACHED_END);
                }
            }, scrollEventThrottle: 400, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.Pressable, { disabled: !user.header_url, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, { uri: user.header_url }) },
                react_1.default.createElement(react_native_1.Image, { source: user?.header_url ? { uri: user.header_url } : images_1.images.NoImages, resizeMode: "cover", style: styles_1.default.backgroundImage })),
            isBlocked || isBlocking ? (react_1.default.createElement(react_native_1.View, { style: styles_1.default.userInfo },
                react_1.default.createElement(react_native_1.View, { style: [
                        styles_1.default.row,
                        {
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                        },
                    ] },
                    react_1.default.createElement(react_native_1.Pressable, { disabled: !user.thumbnail_url, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, {
                            uri: user.image_url,
                        }) },
                        react_1.default.createElement(react_native_1.Image, { source: user?.thumbnail_url
                                ? { uri: user.thumbnail_url }
                                : images_1.images.AvatarDefaul, resizeMode: "cover", style: styles_1.default.avatar })),
                    react_1.default.createElement(components_3.SubUserButton, { user: user, isBlocking: isBlocking, isBlocked: isBlocked, isMute: isMute, toggleBlockUser: toggleBlockUser, toggleMuteUser: toggleMuteUser })),
                react_1.default.createElement(react_native_1.View, { style: [
                        styles_1.default.row,
                        {
                            alignItems: 'center',
                            marginTop: (0, scale_1.scale)(8),
                        },
                    ] },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.fullName }, user?.nickname)),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.username },
                    "@",
                    user?.user_handle),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.blockTitle }, `@${user?.user_handle || ''}さん${isBlocked ? 'を' : 'は'}\n${isBlocked ? 'ブロックしました' : 'あなたをブロックしました'}`),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.blockDescription }, `@${user?.user_handle || ''}${isBlocked
                    ? 'さんをブロックしているため'
                    : 'さんにブロックされているため'}\n@${user?.user_handle || ''}${isBlocked
                    ? 'さんのコンテンツは表示されません。'
                    : 'さんのコンテンツを表示できません。'}`))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.userInfo },
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.row,
                            {
                                justifyContent: 'space-between',
                                alignItems: 'flex-end',
                            },
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { disabled: !user.thumbnail_url, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, {
                                uri: user.image_url,
                            }) },
                            react_1.default.createElement(react_native_1.Image, { source: user?.thumbnail_url
                                    ? { uri: user.thumbnail_url }
                                    : images_1.images.AvatarDefaul, resizeMode: "cover", style: styles_1.default.avatar })),
                        react_1.default.createElement(components_3.SubUserButton, { user: user, isBlocking: isBlocking, isBlocked: isBlocked, isMute: isMute, toggleBlockUser: toggleBlockUser, toggleMuteUser: toggleMuteUser })),
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.row,
                            {
                                alignItems: 'center',
                                marginTop: (0, scale_1.scale)(8),
                            },
                        ] },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.fullName }, user?.nickname || constants_1.DEFAULT_NAME),
                        isMute && react_1.default.createElement(icons_1.IC_MUTE, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20) })),
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.username },
                        "@",
                        user?.user_handle),
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, { marginTop: (0, scale_1.scale)(12), zIndex: 1 }] },
                        react_1.default.createElement(components_3.FollowButton, { user: user, handleUpdateUser: getUserDetail, isAnonymous: myProfile?.registration_status == 0 }),
                        !!user?.is_followed && react_1.default.createElement(components_3.NotifySettings, { user: user })),
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, styles_1.default.followAnalyst] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => (0, rootNavigation_1.push)(Routes_1.default.FOLLOW_SCREEN, {
                                initTabIndex: 0,
                                userHandle: user?.user_handle,
                            }), style: styles_1.default.followItem },
                            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.followItemLabel }, "\u30D5\u30A9\u30ED\u30FC"),
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.followItemValue }, (0, helpler_1.formatNumber)(user?.follows || 0))),
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => (0, rootNavigation_1.push)(Routes_1.default.FOLLOW_SCREEN, {
                                initTabIndex: 1,
                                userHandle: user?.user_handle,
                            }), style: styles_1.default.followItem },
                            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.followItemLabel }, "\u30D5\u30A9\u30ED\u30EF\u30FC"),
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.followItemValue }, (0, helpler_1.formatNumber)(user?.followers || 0)))),
                    !!user?.biography && (react_1.default.createElement(react_native_hyperlink_1.default, { onPress: (url) => react_native_1.Linking.openURL(url), linkStyle: {
                            color: '#06c',
                            textDecorationLine: 'underline',
                        } },
                        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.introduce }, user?.biography
                            .split(helpler_1.hashtagRegex)
                            .map((string, index) => {
                            if (string.match(helpler_1.hashtagRegex)) {
                                return (react_1.default.createElement(react_native_1.Text, { key: index, style: { color: '#007AFF' }, onPress: () => {
                                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                            screen: Routes_1.default.HASHTAG_DETAIL,
                                            params: {
                                                hagTag: string,
                                                type: 0,
                                                typeHashTag: 4,
                                            },
                                        });
                                    } }, string));
                            }
                            else {
                                return react_1.default.createElement(react_native_1.Text, { key: index }, string);
                            }
                        })))),
                    !!user?.video_url ? (helpler_1.isWeb ? (react_1.default.createElement(react_native_1.View, { style: styles_1.default.introduceVideo },
                        react_1.default.createElement("video", { width: "100%", height: "100%", controls: true, src: user.video_url }))) : (react_1.default.createElement(react_native_1.View, { style: styles_1.default.introduceVideo }))) : null,
                    !!user?.location && (react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.row,
                            { marginTop: (0, scale_1.scale)(12), alignItems: 'center' },
                        ] },
                        react_1.default.createElement(icons_1.IC_LOCATION, { width: (0, scale_1.scale)(18), height: (0, scale_1.scale)(18) }),
                        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.locationText }, user?.location))),
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.date },
                        (0, moment_1.default)(user?.start_date).format('YYYY年MM月'),
                        "\u304B\u3089\u5229\u7528\u3057\u3066\u3044\u307E\u3059")),
                user?.user_id && (react_1.default.createElement(components_2.TabBar, { userId: user?.user_id, userNickname: user.nickname || constants_1.DEFAULT_NAME, publicHashtags: user?.public_hash_tags || [], privateHashtags: [], isMyProfile: false, isFollowed: user.is_followed == 1 })))))),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = UserProfileScreen;
